///
/// EarthBrowser
///
/// Created by Matt Giger on 9/5/2026
/// Copyright (c) 2026 Geodata Labs
///

import { DesignColors } from "@/earthbrowser/design-system/DesignColors"
import { HurricaneSymbolGeometry } from "@/earthbrowser/dataset-distribution/hurricanes/HurricaneSymbolGeometry"
import { TextRenderer } from "@/earthbrowser/entities/TextNode/TextRenderer"
import { NodeBase } from "@stovokor/engine/NodeBase"
import { rgba, type color } from "@stovokor/math/color"
import { type Material } from "@stovokor/shader/Material"
import { type StovokorContext } from "@stovokor/StovokorContext"

/**
 * The classic newscast tropical cyclone symbol as an extruded, lit 3D mesh:
 * an open-eyed red disc with two tapering comma arms, rendered through the
 * same lit shader as the synoptic H/L pressure markers. Spin is applied by
 * the parent node; chirality is baked into the geometry so the arms trail
 * the rotation in either hemisphere.
 */
export class HurricaneSymbolNode extends NodeBase implements Material {
	public available = true
	public color: color = DesignColors.MARKER_STORM_SYMBOL
	public transparency = false

	constructor(context: StovokorContext, counterclockwise: boolean) {
		super()
		this.renderer = new TextRenderer(context, new HurricaneSymbolGeometry(context, counterclockwise), this)
	}

	/** Fade the solid red down (used while a storm is focused) */
	public setOpacity(opacity: number): void {
		const base = DesignColors.MARKER_STORM_SYMBOL
		this.color = rgba(base.r, base.g, base.b, base.a * opacity)
		this.transparency = opacity < 1
	}
}
